import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../utils/Auth";

const RequireNotAuth = () => {
  const { user }:any = useAuth();
  const isLogin = Object.values(user).length !== 0 && user.constructor === Object
  const location = useLocation();

  return (
    isLogin
      ? <Navigate to="/" state={{ from: location }} replace />
      : <Outlet />
  );
}

export default RequireNotAuth;
